import DocumentView from './components/DocumentView';
import KBHeader from './components/KBHeader';
import {
    KBGlobalContextProvider
} from './knowledgeBuilderContext/KBGlobalContext';
import './KBStyles.css';
import KBSidebar from './components/KBSidebar';
import KBSidebarContext from './knowledgeBuilderContext/KBSidebarContext';
import {
    FileManagerProvider
} from 'shared/context/FileManagerContext';
import UploadManagerDialog from './components/UploadManagerDialog';
import {
    useContext
} from 'react';
import {
    KBContext
} from './knowledgeBuilderContext/KBGlobalContext';
import {
    useParams
} from 'react-router-dom';
import {
    PanelErrorBoundary
} from 'shared/components/ErrorBoundary';

/**
 * This is the main view of the Knowledge Builder that would contain each components and with sub components inside.
 * It will house a context that would be used for the entire Knowledge Builder.
 * @component
 */
function KBFileManagerContent() {
    const {
        uploadProgress, uploadDialogOpen, setUploadDialogOpen
    } = useContext(KBContext);
    const {
        collectionId, fileName
    } = useParams();

    return (
        <>
            <div className="bg-background flex flex-grow">
                {/* Main view */}
                <div className="grid grid-rows-[auto_1fr] flex-grow">
                    <KBHeader />
                    {/* Tier 3 — DocumentView renders whatever the extractor
                        stored for this file. The KB header and the sidebar
                        (where the user picks a different file) outlive it. */}
                    <PanelErrorBoundary
                        name="kb-document-view"
                        title="This document could not be displayed"
                        recordType="collection file"
                        recordId={fileName}
                        recordLabel={collectionId}
                        resetKeys={[collectionId, fileName]}
                    >
                        <DocumentView />
                    </PanelErrorBoundary>
                </div>

                {/* Side bar component */}
                <KBSidebarContext>
                    <KBSidebar />
                </KBSidebarContext>
            </div>
            <UploadManagerDialog
                isOpen={uploadDialogOpen}
                onClose={() => setUploadDialogOpen(false)}
                uploadProgress={uploadProgress}
            />
        </>
    );
}

export default function KBFileManager() {
    return (
        <>
            <FileManagerProvider>
                <KBGlobalContextProvider>
                    <KBFileManagerContent />
                </KBGlobalContextProvider>
            </FileManagerProvider>
        </>
    );
}